module.exports = __webpack_public_path__ + "img/brackets-square.aeff75b9.svg";